import { useRef } from 'react';
import { NumberInput } from '@mantine/core';

import { NumberInputRightSection } from './number-input-right-section';

import type { NumberInputHandlers, NumberInputProps } from '@mantine/core';

type CustomNumberInputProps = Omit<NumberInputProps, 'handlersRef' | 'hideControls' | 'rightSection' | 'rightSectionPointerEvents'> & {
  internalLabel?: string;
};

export const CustomNumberInput = ({ internalLabel, disabled, rightSectionWidth, ...rest }: CustomNumberInputProps) => {
  const handlersRef = useRef<NumberInputHandlers | undefined>(undefined);
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <NumberInput
      ref={inputRef}
      disabled={disabled}
      handlersRef={handlersRef}
      hideControls
      rightSection={<NumberInputRightSection disabled={disabled} handlersRef={handlersRef} inputRef={inputRef} label={internalLabel} />}
      rightSectionPointerEvents='all'
      rightSectionWidth={rightSectionWidth ?? (internalLabel ? 70 : 40)}
      {...rest}
    />
  );
};
